var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-input-text', {
    class: _vm.classes,
    attrs: {
      "autocomplete": "off",
      "theme": _vm.theme,
      "value": _vm.inputValue,
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.select || _vm.readonly,
      "caption": _vm.caption,
      "error": _vm.error,
      "name": _vm.name,
      "type": _vm.type,
      "maxlength": _vm.maxlength
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": _vm.handleInput,
      "assistant-before-leave": function($event) {
        _vm.isLeaving = true
      },
      "assistant-after-leave": function($event) {
        _vm.isLeaving = false
      }
    },
    nativeOn: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleKeyEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.handleKeyDown($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.handleKeyUp($event)
      }]
    },
    scopedSlots: _vm._u([{
      key: "assistant-action",
      fn: function(props) {
        return [_c('v-icon-button', {
          class: _vm.theme.eventsNone
        }, [_vm._v("\n            keyboard_arrow_down\n        ")])]
      }
    }, {
      key: "assistant",
      fn: function(props) {
        var _obj;

        return [(_vm.isOpen) ? _c('div', {
          directives: [{
            name: "shadow",
            rawName: "v-shadow",
            value: (2),
            expression: "2"
          }],
          class: ( _obj = {}, _obj[_vm.theme.select] = _vm.select, _obj )
        }, [_c('div', {
          class: _vm.theme.autosuggestsContainer
        }, [_c('v-dropdown-raw', {
          attrs: {
            "value": _vm.suggestions[_vm.selectedIndex],
            "items": _vm.suggestions,
            "theme": _vm.dropdownTheme
          },
          on: {
            "select": function($event) {
              _vm.handleSelect($event);
              _vm.clearValueCache();
            }
          },
          nativeOn: {
            "mouseleave": function($event) {
              _vm.handleMouseleave($event)
            },
            "mouseenter": function($event) {
              _vm.handleMouseenter($event)
            }
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function(props) {
              return [_vm._t("item", [_c('span', [_vm._v(_vm._s(_vm.getItemValue(props.item)))])], {
                item: props.item
              })]
            }
          }])
        })], 1)]) : _vm._e()]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-236e30a9","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Autosuggest/Autosuggest.vue
// module id = 523
// module chunks = 0